import { Controller, ControllerRenderProps, FieldValues, useFormContext } from "react-hook-form";
import React from "react";
import classNames from "classnames";
import _ from "lodash";

interface FormFieldProps extends IFormField {
  render: ({ field }: { field: ControllerRenderProps<FieldValues, string> }) => React.ReactElement;
}

export type IFormField = {
  name: string;
  label?: string;
  hasRequiredAsterisk?: boolean;
  note?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValue?: any;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
};

export const FormField: React.FC<FormFieldProps> = ({
  name,
  label,
  hasRequiredAsterisk,
  render,
  note,
  defaultValue,
  className,
}) => {
  const form = useFormContext();

  return (
    <div className={classNames("flex flex-col w-full gap-1", className)}>
      <label
        htmlFor={name}
        className={classNames("font-semibold", {
          "after:content-['*'] after:text-red-400 after:text-sm": hasRequiredAsterisk,
        })}
      >
        {label}
      </label>

      <div>
        <Controller
          name={name}
          control={form.control}
          defaultValue={defaultValue}
          render={({ field, formState }) => {
            return (
              <>
                {render({ field })}

                {_.get(formState.errors, name) && (
                  <span className="mt-2 text-sm text-red-500">
                    {_.get(formState.errors, name)?.message?.toString()}
                  </span>
                )}
              </>
            );
          }}
        />
      </div>

      {note && <span className="text-sm text-gray-500">{note}</span>}
    </div>
  );
};
